module.exports = __webpack_public_path__ + "img/img_index_expers@2x.16aae3a5.png";